// export default DairyProductsReport;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, getDateWithDay, formatDate } from "../../comman/config";
import { Link } from 'react-router-dom';
import { VegRequirementFilter } from "../../components/Filter/VegRequirementFilter.js";
import Loader from "../../components/Loader.js";
import { isFilterActive, matchFilterText, patchFilter } from "../../components/Filter/columnFilter";
import ColumnFilterRow from "../../components/Filter/ColumnFilterRow";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import toast, { Toaster } from "react-hot-toast";
import MainIssueDetailsModal from "../../components/MainStockModal.js";

function VegStockReport() {
    const today = new Date().toISOString().split("T")[0];
    const [reportData, setReportData] = useState([]);
    // Inline per-column filters: { [colKey]: { op, v1, v2 } }. FILTER_COLS lists the 19 body
    // columns in table order and returns each cell's plain text -- several cells render a link,
    // and a filter has to see the number inside it, not the markup.
    const [filters, setFilters] = useState({});
    const setColFilter = (key, patch) => setFilters((prev) => patchFilter(prev, key, patch));
    const FILTER_COLS = [
        { key: 'date',        text: (r) => formatDate(r.date) },
        { key: 'ingredient',  text: (r) => r.ingredient_name },
        { key: 'opening',     text: (r) => r.opening_qty },
        { key: 'required',    text: (r) => r.total_required_qty },
        { key: 'order',       text: (r) => r.order_qty },
        { key: 'purchase',    text: (r) => r.purchase_qty },
        { key: 'recv_gross',  text: (r) => r.received_gross_qty },
        { key: 'recv_net',    text: (r) => r.received_net_qty },
        { key: 'iss_break',   text: (r) => r.issued_qty?.breakfast },
        { key: 'iss_lunch',   text: (r) => r.issued_qty?.lunch },
        { key: 'iss_noon',    text: (r) => r.issued_qty?.noon },
        { key: 'iss_dinner',  text: (r) => r.issued_qty?.dinner },
        { key: 'iss_night',   text: (r) => r.issued_qty?.night },
        { key: 'iss_total',   text: (r) => r.total_issued_qty },
        { key: 'returned',    text: (r) => r.total_returned_qty || 0 },
        { key: 'closing',     text: (r) => r.closing_qty },
        { key: 'physical',    text: (r) => r.physical_stock_qty !== null ? r.physical_stock_qty : '-' },
        { key: 'stock_diff',  text: (r) => r.stock_diff !== null ? r.stock_diff : '-' },
        { key: 'stock_adj',   text: (r) => r.stock_adj !== null ? r.stock_adj : '-' },
    ];
    const activeFilterCols = FILTER_COLS.filter((c) => isFilterActive(filters[c.key]));
    const visibleRows = reportData.filter((r) => activeFilterCols.every((c) => matchFilterText(c.text(r), filters[c.key])));
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [ingredient, setIngredient] = useState([]);
    const [session, setSession] = useState({});
    const [loading, setLoading] = useState(false);
    const [noRecordsFound, setNoRecordsFound] = useState(false);
    const [issueDetails, setIssueDetails] = useState([]);
    const [selectedDetail, setSelectedDetail] = useState({
        date: "",
        ingredient_id: null,
        ingredient_name: "",
        session_id: null,
        session_name: ""
    });
    const [showIssueModal, setShowIssueModal] = useState(false);

    const [showReturnModal, setShowReturnModal] = useState(false);
    const [returnDetails, setReturnDetails] = useState([]);
    const [selectedReturnDetail, setSelectedReturnDetail] = useState({
            date: "",
            ingredient_id: null,
            ingredient_name: "",
            session_id: null,
            session_name: ""
        });

    useEffect(() => {
        if (fromDate) {
            getMainStoreInventoryReport();
        }
    }, [fromDate, toDate, ingredient, session]);

    const handelFilterChange = async (from_date, to_date, session, item, requirement_status, order_status, order_id, purchase_status, receipt_status,issueStatus,ingredient) => {
        setFromDate(from_date);
        setToDate(to_date);
        setIngredient(ingredient);
        setSession(session);
  };

    const getMainStoreInventoryReport = async () => {
        setLoading(true);
        setNoRecordsFound(false);
        try {

            let ingredientIds = null;
            if (ingredient) {
                // If it's an array (multi-select), map the values
                if (Array.isArray(ingredient)) {
                    ingredientIds = ingredient.map(item => item.value);
                }
                // If it's a single object (single select)
                else if (ingredient.value && ingredient.value !== "all") {
                    ingredientIds = ingredient.value;
                }
            }
            let sessionId = null;
            if (session && session.value && session.value !== "all") {
                sessionId = session.value;
            }

            const response = await axios.post(`${baseUrl}/reports/veg_store_stock_report`, {
                from_date: fromDate,
                to_date: toDate,
                ingredient_id: ingredientIds, // Changed to ingredient_id to match backend
                session_id: sessionId // Changed to session_id to match backend
            });

            setReportData(response.data.data || []);
            setNoRecordsFound((response.data.data || []).length === 0);
        } catch (error) {
            console.error("Error fetching dairy products report:", error);
            toast.error("Failed to fetch report data");
            setNoRecordsFound(true);
        } finally {
            setLoading(false);
        }
    };

    const displayIssueDetails = async (e, date, ingredient_id, ingredient_name, session_id, session_name) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.get(`${baseUrl}/main_store_issue/issue_details`, {
                params: {
                    date: date,
                    ingredient_id: ingredient_id,
                    session_id: session_id
                }
            });

            setIssueDetails(response.data.data || []);
            setSelectedDetail({
                date,
                ingredient_id,
                ingredient_name,
                session_id,
                session_name
            });

            setShowIssueModal(true);
        } catch (error) {
            console.error("Error fetching issue details:", error);
            toast.error("Failed to load issue details");
        } finally {
            setLoading(false);
        }
    };

    const displayReturnDetails = async (e, date, ingredient_id, ingredient_name) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.get(`${baseUrl}/issue_net/return_details`, {
                params: {
                    date: date,
                    ingredient_id: ingredient_id,
                }
            });

            setReturnDetails(response.data.data || []);
            console.log("return details:", returnDetails)
            setSelectedDetail({
                date,
                ingredient_id,
                ingredient_name,
            });
            setSelectedReturnDetail(returnDetails);

            setShowReturnModal(true);
        } catch (error) {
            console.error("Error fetching return details:", error);
            toast.error("Failed to load return details");
        } finally {
            setLoading(false);
        }
    };

    const renderSessionQty = (qty, date, ingredientId, ingredientName, sessionId, sessionName) => {
        // Check if the qty contains a pending indicator 'P'

        if (qty === 0 || qty === '0') {
            return <span>{qty}</span>;
        }

        // For regular items - render clickable link with blue color
        return (
            <a
                href="#"
                className="underline text-blue-500 cursor-pointer"
                onClick={(e) => displayIssueDetails(e, date, ingredientId, ingredientName, sessionId, sessionName)}
            >
                {qty}
            </a>
        );
    };

    return (
        <div className="p-4">
            {loading && <Loader />}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
                    Veg Stock Report
                </h1>
                <Link to="/">
                    <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                </Link>
                <Toaster position="top-center" reverseOrder={false} />
            </div>

            <div className="relative shadow-md sm:rounded-lg">
                <VegRequirementFilter handleFilterChange={handelFilterChange} handleClearFilters={() => setFilters({})} page="stock_report" />
            </div>

            {noRecordsFound && <NoRecordsFound />}

            {reportData.length > 0 && (
                <div className="overflow-x-auto mt-5">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 border-collapse border border-gray-300">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">Date</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">શાકભાજીનું નામ</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">ઓપનિંગ જથ્થો.</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">જરૂરિયાત (Req.Qty)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">ઓર્ડર (Order qty.)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">ખરીદી (Purchase Qty.)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" colSpan="2">મળેલ (Received qty.)</th>
                                
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" colSpan="6">
                                    <div>Total Issued Qty. (Net)</div>
                                    <div>કુલ આપેલ જથ્થો. (નેટ)</div>
                                </th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">પરત (Returned Qty.)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">Closing Qty.</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">Physical Stock Qty</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">Stock Diff</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center" rowSpan="2">Stock Adjusted</th>
                            </tr>
                            <tr>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">(Gross)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">(Net)</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">નાસ્તો</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">લંચ</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">બપોર</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">ડીનર</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">રાત્રે</th>
                                <th scope="col" className="px-2 py-1 border border-gray-300 text-center">ટોટલ ઇસ્યુ</th>
                            </tr>
                            {/* Inline per-column filter row (contains / = / ≤ / ≥ / between / not between) */}
                            <ColumnFilterRow
                                thClassName="px-1 py-1 border border-gray-300 bg-gray-50 align-top"
                                cols={FILTER_COLS.map((c) => ({ key: c.key }))}
                                filters={filters}
                                onChange={setColFilter} />
                        </thead>
                        <tbody>
                            {visibleRows.map((item, index) => (
                                <tr key={index} className="border-b border-gray-300">
                                    <td className="px-2 py-1 border border-gray-300 text-center">{formatDate(item.date)}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.ingredient_name}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.opening_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.total_required_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.order_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.purchase_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.received_gross_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.received_net_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {renderSessionQty(item.issued_qty.breakfast, item.date, item.ingredient_id, item.ingredient_name, 3, "Breakfast")}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {renderSessionQty(item.issued_qty.lunch, item.date, item.ingredient_id, item.ingredient_name, 1, "Lunch")}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {renderSessionQty(item.issued_qty.noon, item.date, item.ingredient_id, item.ingredient_name, 4, "Noon")}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {renderSessionQty(item.issued_qty.dinner, item.date, item.ingredient_id, item.ingredient_name, 2, "Dinner")}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {renderSessionQty(item.issued_qty.night, item.date, item.ingredient_id, item.ingredient_name, 5, "Night")}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.total_issued_qty}</td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {item.total_returned_qty > 0 ? (
                                            <a
                                                href="#"
                                                className="underline text-blue-500 cursor-pointer"
                                                onClick={(e) => displayReturnDetails(e, item.date, item.ingredient_id, item.ingredient_name)}
                                            >
                                                {item.total_returned_qty}
                                            </a>
                                        ) : (
                                            item.total_returned_qty || 0
                                        )}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">{item.closing_qty}</td>
                                    <td className={`px-2 py-1 border border-gray-300 text-center ${item.stock_diff !== null && parseFloat(item.stock_diff) !== 0 ? 'bg-yellow-100' : ''}`}>
                                        {item.physical_stock_qty !== null ? item.physical_stock_qty : '-'}
                                    </td>
                                    <td className={`px-2 py-1 border border-gray-300 text-center ${item.stock_diff !== null && parseFloat(item.stock_diff) !== 0 ? 'bg-yellow-100' : ''}`}>
                                        {item.stock_diff !== null ? item.stock_diff : '-'}
                                    </td>
                                    <td className="px-2 py-1 border border-gray-300 text-center">
                                        {item.stock_adj !== null ? item.stock_adj : '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {showIssueModal && (
                <MainIssueDetailsModal
                    showModal={showIssueModal}
                    setShowModal={setShowIssueModal}
                    issueDetails={issueDetails}
                    date={selectedDetail.date}
                    ingredient={selectedDetail.ingredient_name}
                    sessionName={selectedDetail.session_name}
                    selectedDetail={selectedDetail}
                    type={1}
                />
            )}
            {showReturnModal && (
                <MainIssueDetailsModal
                    showModal={showReturnModal}
                    setShowModal={setShowReturnModal}
                    issueDetails={returnDetails}
                    date={selectedDetail.date}
                    ingredient={selectedDetail.ingredient_name}
                    selectedDetail={selectedReturnDetail}
                    type={2}
                />
            )}

        </div>
    );
}

export default VegStockReport;